import { ReactNode } from 'react';
import { IUser, Actions, Subjects, RoleId } from '@efexteam/permission-manager';

/**
 * Custom actions for the application.
 * These are used to define the permissions for different roles in the application.
 */
export const AppActions = {
  ...Actions,
  VIEW: 'view',
};

/**
 * Custom subjects for the application.
 * These are used to define the resources that the permissions apply to.
 */
export const AppSubjects = {
  ...Subjects,
};

/**
 * Interface for the extended user object.
 * This extends the IUser interface from the permission manager.
 */
export interface IExtendedUser extends IUser {
  legalRepresentative?: {
    roleId?: RoleId;
    [key: string]: unknown;
  };
}

/**
 * Props for the PermissionManagerProvider component.
 */
export interface PermissionManagerProps {
  children: ReactNode;
}
